import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { MomentType, ProfileDataType, ProfileField } from '../../../types/profile';
import { momentTypeIcons } from '../../../utils/iconUtils';

interface MomentProps {
  field: ProfileField;
  handleClick?: (active: boolean, field: ProfileField) => void;
  active?: boolean;
}
export default function Moment({ field, handleClick, active = false }: MomentProps): JSX.Element {
  const { t } = useTranslation();
  const [year, month, day] = field.moment?.date.split('-') || field.birthDate?.split('-') || [];
  return (
    <div
      key={field.id!}
      onClick={() => handleClick?.(active, field)}
      className={classNames(
        'flex w-full cursor-pointer items-center justify-between rounded-lg border bg-secondary px-3 py-2',
        {
          'bg-secondary-200': active,
        },
      )}>
      <div className="flex items-center gap-3">
        <div
          className={classNames('flex items-center justify-center rounded-lg bg-secondary-200 p-1 text-primary', {
            'bg-secondary-50': active,
          })}>
          {momentTypeIcons[(field.moment?.momentType || MomentType.CHILDBIRTH) as keyof typeof momentTypeIcons]}
        </div>
        <div className="text-sm font-medium text-primary-900">
          <p>
            {field.moment?.momentType === MomentType.WEDDING
              ? t('form.userData.wedding')
              : field.dataType === ProfileDataType.BIRTHDATE
                ? t('form.userData.birthDateOwner')
                : t('form.userData.birthDateOther', { name: field.moment?.name })}
          </p>
          <p className="text-sm font-normal text-gray-700">{`${day}-${month}-${year}`}</p>
        </div>
      </div>
      {handleClick && (
        <div className="flex h-8 w-8 items-center justify-center">
          <input
            type="checkbox"
            className="form-checkbox h-5 w-5 cursor-pointer rounded-full border-secondary-50 bg-secondary-200 text-primary-300 accent-primary-900 focus:ring-0 focus:ring-transparent"
            checked={active}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}
